(() => {

  var AccordionApp = (() => {
    var toggle = (trigger) => {
      if (!trigger) return;
      const wrapper = document.querySelector(`[js-load-more-wrapper=${trigger.getAttribute('js-load-more-trigger')}]`);
      if (!wrapper) return;
      if (trigger.classList.contains('active')) {
        trigger.classList.remove('active');
        wrapper.classList.remove('active');
        wrapper.style.maxHeight = '0px';
      } else {
        trigger.classList.add('active');
        wrapper.classList.add('active');
        wrapper.style.maxHeight = wrapper.scrollHeight + 'px';
      }
    }
    var initialize = () => {
      document.querySelectorAll('[js-load-more-trigger]').forEach(element => {
        element.addEventListener('click', () => {
          toggle(element);
        });
      });
    }
    return {
      init: initialize
    }
  })();

  var TabApp = (() => {
    var open = (container, tab_id) => {
      if (!container) return;
      container.querySelectorAll('[js-tab-header], [js-tab-body]').forEach(element => {
        element.classList.remove('active');
        if (String(element.getAttribute('js-tab-header')) === String(tab_id)) {
          element.classList.add('active');
        }
        if (String(element.getAttribute('js-tab-body')) === String(tab_id)) {
          element.classList.add('active');
        }
      });
    }
    var initialize = () => {
      document.querySelectorAll('[js-tab] [js-tab-header]').forEach(element => {
        element.addEventListener('click', () => {
          open(element.closest('[js-tab]'), element.getAttribute('js-tab-header'));
        });
      });
    }
    return {
      init: initialize
    }
  })();

  let reviewAppBlockStyleBugFix = (() => {
    let initialize = () => {
      const reviewRatingStarEle = document.querySelectorAll(".jdgm-all-reviews-widget .jdgm-histogram__bar-content");
      const reviewRatingPercentageEle = document.querySelectorAll(".jdgm-all-reviews-widget .jdgm-histogram__percentage");
      const reviewRatingNumberEle = document.querySelectorAll(".jdgm-all-reviews-widget .jdgm-histogram__frequency");
      const totalReviewTextEle = document.querySelector(".jdgm-all-reviews-widget .jdgm-all-reviews__summary-text");
      
      let percentArr = [0, 0, 0, 0, 0];
      let restPercentage = 0;
      let totalReviewNum = 0;
      let reviewArr = [];

      reviewRatingNumberEle.forEach((ele) => {
        let numStr = ele.textContent;
        console.log("This is the number", numStr);
        if (numStr) {
          numStr = String(numStr);
          numStr = numStr.replace("(", "");
          numStr = numStr.replace(")", "");
          totalReviewNum += Number(numStr);
          reviewArr.push(Number(numStr));
        }
      });

      let subTotalPercent = 0;
      for (let i = 4; i >= 0; i --) {
        if (i != 0) {
          let percent = Math.round((reviewArr[i] / totalReviewNum) * 100);
          percentArr[i] = percent;
          subTotalPercent += percent;
        } else {
          percentArr[i] = 100 - subTotalPercent;
        }
      }

      function waitForElement(selector) {
        return new Promise(resolve => {
          const element = document.querySelector(selector);
          if (element) {
            return resolve(element);
          }

          const observer = new MutationObserver(() => {
            const el = document.querySelector(selector);
            if (el) {
              resolve(el);
              observer.disconnect();
            }
          });

          observer.observe(document.body, {
            childList: true,   // ⚠️ correct property (not child_list)
            subtree: true
          });
        });
      }

      function applyReviewText(el, totalReviewNum) {
        el.innerHTML = `Basierend auf ${totalReviewNum} Bewertungen`;
      }
      // Usage
      waitForElement(".jdgm-all-reviews__summary-text")
        .then(el => {
          console.log("Found it!", el);
          applyReviewText(el, totalReviewNum);
          
           const observer = new MutationObserver(() => {
            // Disconnect to avoid infinite loop
            observer.disconnect();

            applyReviewText(el, totalReviewNum);

            // Re-observe after applying
            observer.observe(el, { childList: true, subtree: true, characterData: true });
          });

          observer.observe(el, { childList: true, subtree: true, characterData: true });

          for (let i = 0; i < 5; i ++) {
            reviewRatingStarEle[i].style.width = `${percentArr[i]}%`;
            reviewRatingPercentageEle[i].innerHTML = `${percentArr[i]}%`;
          }
        });

    }
    return {
      init: initialize
    }
  })();
  
  var SkinResultsSliderApp = (() => {
    var initialize = () => {
      const reviewSections = document.querySelectorAll("[js-quiz-reviews-section]");

      reviewSections.forEach((reviewSection) => {
        const tabItems = reviewSection.querySelectorAll("[js-tab-item]");
        const cardItems = reviewSection.querySelectorAll("[js-card-item]");
        const popupClick = reviewSection.querySelectorAll("[js-reviews-popup-click]");
        const popupContent = reviewSection.querySelectorAll("[js-reviews-popup-item]");
        const removeIcon = reviewSection.querySelectorAll("[js-reviews-popup-remove]");
        const popupOverlay = reviewSection.querySelectorAll("[js-reviews-popup-overlay]");
        const sliderEl = reviewSection.querySelector("[js-reviews-slider]");
        const nextBtn = reviewSection.querySelector("[js-reviews-slider-next-btn]");
        const prevBtn = reviewSection.querySelector("[js-reviews-slider-prev-btn]");
        let swiper = null;

        function initSwiper() {
            if (swiper) swiper.destroy(true, true);
            if (!sliderEl) return;
            swiper = new Swiper(sliderEl, {
                slidesPerView: 1.375,
                spaceBetween: 12,
                watchSlidesProgress: true,
                draggable: true,
                autoHeight: false,
                watchOverflow: true,
                threshold: 10,
                mousewheel: { forceToAxis: true },
                navigation: {
                    nextEl: nextBtn,
                    prevEl: prevBtn,
                },
                breakpoints: {
                    520: { slidesPerView: 2, spaceBetween: 12 },
                    720: { slidesPerView: "auto", spaceBetween: 14 },
                    1024: { slidesPerView: "auto", spaceBetween: 20 },
                },
            });
        }
        function updateCards() {
            const activeTags = [];
            tabItems.forEach(tab => {
                if (tab.classList.contains('active') && tab.dataset.tag !== 'alle') {
                    activeTags.push(tab.dataset.tag);
                }
            });

            const alleActive = Array.from(tabItems).some(
                tab => tab.dataset.tag === 'alle' && tab.classList.contains('active')
            );

            cardItems.forEach(card => {
                const cardTag = card.dataset.cardTag?.toLowerCase().replace(/\s+/g, '-'); // handleize
                if (alleActive) {
                    card.classList.add("active");
                } else {
                    const show = activeTags.includes(cardTag);
                    card.classList.toggle("active", show);
                }
            });
        }

        tabItems.forEach(tab => {
            tab.addEventListener("click", function () {
                const tag = this.dataset.tag;
                const alleTabs = reviewSection.querySelectorAll('[data-tag="alle"]');

                if (tag === 'alle') {
                    tabItems.forEach(t => {
                        if (t.dataset.tag !== 'alle') {
                            t.classList.remove("active");
                        }
                    });
                    alleTabs.forEach(t => t.classList.add("active"));
                } else {
                    alleTabs.forEach(t => t.classList.remove("active"));

                    const isActive = this.classList.contains('active');

                    const sameTagTabs = reviewSection.querySelectorAll(`[data-tag="${tag}"]`);
                    sameTagTabs.forEach(t => {
                        t.classList.toggle("active", !isActive);
                    });
                }

                updateCards();
                initSwiper();
            });
        });

        popupClick.forEach((el, index) => {
            el.addEventListener("click", () => {
                popupContent.forEach((content, i) => {
                    if (i !== index) content.classList.remove("is-open");
                });
                popupContent[index].classList.add("is-open");
            });
        });

        removeIcon.forEach(icon => {
            icon.addEventListener("click", function () {
                this.closest("[js-reviews-popup-item]").classList.remove("is-open");
            });
        });

        popupOverlay.forEach(overlay => {
            overlay.addEventListener("click", function () {
                this.closest("[js-reviews-popup-item]").classList.remove("is-open");
            });
        });

        const alleTabs = reviewSection.querySelectorAll('[data-tag="alle"]');
        alleTabs.forEach(tab => tab.classList.add("active"));

        updateCards();
        initSwiper();

        function formatRelativeGermanDate(dateString) {
            const inputDate = new Date(dateString);
            const today = new Date();
            inputDate.setHours(0, 0, 0, 0);
            today.setHours(0, 0, 0, 0);

            const msPerDay = 24 * 60 * 60 * 1000;
            const diffDays = Math.floor((today - inputDate) / msPerDay);

            if (isNaN(diffDays)) return dateString;

            if (diffDays === 0) {
                return inputDate.toLocaleDateString("de-DE", {
                    day: "2-digit",
                    month: "2-digit",
                    year: "numeric",
                });
            } else if (diffDays === 1) {
                return 'Vor 1 Tag';
            } else if (diffDays < 7) {
                return `Vor ${diffDays} Tagen`;
            } else if (diffDays < 30) {
                const weeks = Math.floor(diffDays / 7);
                return `Vor ${weeks} Woche${weeks > 1 ? 'n' : ''}`;
            } else if (diffDays < 365) {
                const months = Math.floor(diffDays / 30);
                return `Vor ${months} Monat${months > 1 ? 'en' : ''}`;
            } else {
                const years = Math.floor(diffDays / 365);
                return `Vor ${years} Jahr${years > 1 ? 'en' : ''}`;
            }
        }

        reviewSection.querySelectorAll('.reviews-section__date').forEach(el => {
            const dateStr = el.getAttribute('data-date');
            if (dateStr) {
                el.textContent = formatRelativeGermanDate(dateStr.trim());
            }
        });
        
        // select the items according to the quiz result (HL#9)
        let pageType = '';
        let targetTag = '';
        const reviewsEle = document.querySelector(".reviews-section--parent .reviews-section");
        console.log("There is not the review element......");
        if (reviewsEle) {
          pageType = reviewsEle.dataset.pageType;
          console.log("This is the page type---------0-", pageType);

          if (pageType == "neurodermitis") {
            targetTag = "neurodermitis";
          } else if(pageType == "roascea") {
            targetTag = "rosacea";
          } else if(pageType == "akne") {
            targetTag = "post-pill-akne";
          } else if(pageType == "hormonelle") {
            targetTag = "unreine-haut";
          }
        }
        
        tabItems.forEach(tab => {
          if (tab.dataset.tag == targetTag) {
            console.log("This is the page type----------1", targetTag);
            tab.click();
          }
          
          // if (tab.dataset.tag == 'unreine-haut') {
          //   console.log("This is the neuro----------");
          //   tab.click();
          // }
          
          // if (tab.dataset.tag == 'rosacea') {
          //   console.log("This is the neuro----------");
          //   tab.click();
          // }
          
          // if (tab.dataset.tag == 'post-pill-akne') {
          //   console.log("This is the neuro----------");
          //   tab.click();
          // }
        });
      });
    }
    return {
      init: initialize
    }
  })();

  var quizLandingCountdownApp = (() => {
    const PLACEHOLDER_REGEX = /\{\{[^}]+\}\}/;

    function parseDuration(durationStr) {
      if (!durationStr) return null;
      const parts = String(durationStr).trim().split(":");
      if (parts.length !== 3) return null;
      const h = parseInt(parts[0], 10);
      const m = parseInt(parts[1], 10);
      const s = parseInt(parts[2], 10);
      if ([h, m, s].some((n) => Number.isNaN(n) || n < 0)) return null;
      return (h * 3600 + m * 60 + s) * 1000;
    }

    function formatInlineTime(distanceMs) {
      const totalSeconds = Math.max(0, Math.floor(distanceMs / 1000));
      const h = Math.floor(totalSeconds / 3600);
      const m = Math.floor((totalSeconds % 3600) / 60);
      const s = totalSeconds % 60;
      return [h, m, s].map((n) => String(n).padStart(2, "0")).join(":");
    }

    function stripPlaceholder(text) {
      return text.replace(PLACEHOLDER_REGEX, "").replace(/\s+/g, " ").trim();
    }

    function getEndTime(storageKey, durationMs) {
      const now = Date.now();
      const stored = localStorage.getItem(storageKey);

      if (stored) {
        const endTime = parseInt(stored, 10);
        if (!Number.isNaN(endTime) && endTime > now) return endTime;
      }

      const endTime = now + durationMs;
      localStorage.setItem(storageKey, String(endTime));
      return endTime;
    }

    var initialize = () => {
      const timers = [];

      document.querySelectorAll("[data-countdown-duration][data-countdown-storage-key]").forEach((el) => {
        if (!el.querySelector("[data-countdown-hours]")) return;

        const durationMs = parseDuration(el.dataset.countdownDuration);
        if (!durationMs) return;

        const endTime = getEndTime(el.dataset.countdownStorageKey, durationMs);
        timers.push({
          type: "block",
          endTime,
          hoursEl: el.querySelector("[data-countdown-hours]"),
          minutesEl: el.querySelector("[data-countdown-minutes]"),
          secondsEl: el.querySelector("[data-countdown-seconds]"),
        });
      });

      document.querySelectorAll("[data-countdown-inline-text]").forEach((el) => {
        const rawText = el.textContent.trim();

        if (!rawText) return;

        const durationMs = parseDuration(el.dataset.countdownDuration);
        if (!durationMs || !PLACEHOLDER_REGEX.test(rawText)) {
          el.textContent = stripPlaceholder(rawText);
          return;
        }

        const endTime = getEndTime(el.dataset.countdownStorageKey, durationMs);
        const parts = rawText.split(PLACEHOLDER_REGEX);
        const before = parts[0];
        const after = parts[1] || "";
        const spaceBefore = before && !before.endsWith(" ") ? " " : "";
        const spaceAfter = after && !after.startsWith(" ") ? " " : "";
        el.innerHTML =
          before +
          spaceBefore +
          '<span data-countdown-inline-value></span>' +
          spaceAfter +
          after;

        timers.push({
          type: "inline",
          endTime,
          inlineEl: el.querySelector("[data-countdown-inline-value]"),
        });
      });

      function updateAll() {
        const now = Date.now();

        timers.forEach((timer) => {
          const distance = timer.endTime - now;

          if (timer.type === "block") {
            if (distance <= 0) {
              timer.hoursEl.textContent = "00";
              timer.minutesEl.textContent = "00";
              timer.secondsEl.textContent = "00";
              return;
            }

            timer.hoursEl.textContent = String(Math.floor(distance / 3600000)).padStart(2, "0");
            timer.minutesEl.textContent = String(Math.floor((distance % 3600000) / 60000)).padStart(2, "0");
            timer.secondsEl.textContent = String(Math.floor((distance % 60000) / 1000)).padStart(2, "0");
            return;
          }

          if (timer.inlineEl) {
            timer.inlineEl.textContent = formatInlineTime(distance);
          }
        });
      }

      if (timers.length === 0) return;

      updateAll();
      setInterval(updateAll, 1000);
    };

    return {
      init: initialize,
    };
  })();
  
  var quizLandingGallerySliderApp = (() => {
    var initialize = () => {
      const mainSlider = new Flickity('#qpr-product-gallery', {
        draggable: true,
        prevNextButtons: false,
        adaptiveHeight: false,
        wrapAround: false,
        pageDots: true,
        contain: true,
        imagesLoaded: true,
        cellAlign: 'left',
      });
    }
    return {
      init: initialize
    }
  })();
  
  var quizResultATCApp = (() => {
    async function refreshBubbleCount() {
      try {
        const res = await fetch('/cart.js')

        if (res.status === 429) {
          console.warn('[Cart] Rate limited — skipping count update')
          return
        }

        const data = await res.json()
        document.querySelectorAll('.cart-count').forEach(el => {
          el.textContent = data.item_count
        })
      } catch (err) {
        console.error('[Cart] count refresh error:', err)
      }
    }
    var initialize = () => {
      document.querySelectorAll('.sticky_ATC__btn').forEach(function (btn) {
        btn.addEventListener('click', async function () {
          const variantId = btn.dataset.variantId
          if (!variantId) return

          const originalText = btn.textContent
          btn.disabled       = true
          btn.classList.add('sticky-atc__btn--loading')   // ← spinner on

          try {
            const res = await fetch('/cart/add.js', {
              method:  'POST',
              headers: { 'Content-Type': 'application/json' },
              body:    JSON.stringify({ id: variantId, quantity: 1 }),
            })

            if (!res.ok) throw new Error('Add to cart failed')

            btn.classList.add('sticky-atc__btn--success')

            document.dispatchEvent(new CustomEvent('cart:refresh'))
            document.dispatchEvent(new CustomEvent('theme:cart:update'))
            await refreshBubbleCount()

            const bubbleIconEle = document.querySelector('.cart-drawer-button')
            if (bubbleIconEle) bubbleIconEle.click()

            setTimeout(function () {
              // btn.textContent = originalText
              btn.classList.remove('sticky-atc__btn--success')
              btn.classList.remove('sticky-atc__btn--loading')  // ← spinner off
              btn.disabled = false
            }, 2000)

          } catch (err) {
            console.error('[StickyATC] Add to cart error:', err)
            btn.classList.remove('sticky-atc__btn--loading')    // ← spinner off
            // btn.textContent      = '✗ Fehler'
            btn.style.background = '#e44'
            setTimeout(function () {
              // btn.textContent      = originalText
              btn.style.background = ''
              btn.disabled         = false
            }, 2000)
          }
        })
      });
    }
    return {
      init: initialize
    }
  })();

  var getQuizStep7Result = (() => {
    var initialize = () => {
      let result = localStorage.getItem('quiz_step7_result') || '';
      console.log("This is ths result of step 7", result);

      // result = String(result).replaceAll("|", ",");
      result = result.replace(/\|/g, ',<br />');
      const step7ResultEle = document.querySelector(".qspr-treatment-option p");
      if (step7ResultEle) step7ResultEle.innerHTML = result;
    }
    return {
      init: initialize
    }
  })();

  var App = (() => {
    var initialize = () => {
      AccordionApp.init();
      TabApp.init();
      reviewAppBlockStyleBugFix.init();
      SkinResultsSliderApp.init();
      quizLandingCountdownApp.init();
      quizLandingGallerySliderApp.init();
      quizResultATCApp.init();
      getQuizStep7Result.init();
    }
    return {
      init: initialize
    }
  })();

  document.addEventListener('DOMContentLoaded', () => {
    App.init();
  });

})();